module.exports = __webpack_public_path__ + "static/concerto-2cdd9dd5d590fcccfc9e709fbc4ac9a0.jpg";